module.exports = __webpack_public_path__ + "img/dairy_milk_only.d080d2bc.png";